'use client'
import { ContainerCustom } from '@/components'
import { BREAKPOINTS } from '@/constants'
import { useElementVisibility } from '@/hooks/use-element-visibility'
import { useWindowSize } from '@/hooks/use-window-size'
import { Box, IconButton } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { ContentFixedProductV2 } from './fixed-product/v2'
import { StickyBarBottom } from './stickybar-bottom'
import ButtonControlCartFixed from './button-control-cart-fixed'
import CloseIcon from '@mui/icons-material/Close'
import { scrollBodyHide, scrollBodyShow } from '@/utils/copy-content'

export const WrapperInView = ({ children, data }: { children: React.ReactNode; data: any }) => {
  const ref = useRef(null)
  const { width } = useWindowSize()
  const isMobile = width < BREAKPOINTS.xl
  const [isShow, setIsShow] = useState(false)
  const isTheStickyBarVisible = useElementVisibility('sticky-bar-desktop', { margin: '-150px 0px 0px 0px' })
  const isTheLeftSideVisible = useElementVisibility('left-side-detail-products', {
    margin: '-300px 0px 0px 0px',
  })
  const isTheFooterVisible = useElementVisibility('footer')
  const isInview = !isMobile
    ? !isTheStickyBarVisible && !isTheFooterVisible
    : !isTheFooterVisible && !isTheLeftSideVisible
  const handleOpenCartmobile = () => {
    scrollBodyHide()
    setIsShow(true)
  }
  const handleCloseCartmobile = () => {
    scrollBodyShow()
    setIsShow(false)

    if (window.history.state?.popup) {
      window.history.back()
    }
  }
  const handleScrollReviews = () => {
    const reviewSection = document.getElementById('review')
    if (reviewSection) {
      window.scrollTo({
        top: reviewSection?.offsetTop + 80,
        behavior: 'smooth',
      })
      scrollBodyShow()
      setIsShow(false)
    }
  }

  useEffect(() => {
    const handleBack = () => {
      if (isShow) {
        scrollBodyShow()
        setIsShow(false)
      }
    }
    window.addEventListener('popstate', handleBack)
    return () => {
      window.removeEventListener('popstate', handleBack)
      scrollBodyShow()
    }
  }, [isShow])

  return (
    <>
      <ButtonControlCartFixed onClickShow={handleOpenCartmobile} />
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 110,
          bgcolor: 'rgba(0,0,0,0.5)',
          opacity: isShow ? 1 : 0,
          pointerEvents: isShow ? 'auto' : 'none',
          transition: 'opacity 0.3s ease',
        }}
        onClick={handleCloseCartmobile}
      />
      {isMobile && (
        <AnimatePresence mode="wait">
          {isShow && (
            <Box
              component={motion.div}
              initial={{ y: '100%', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: '100%', opacity: 0 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 30,
                duration: 0.3,
              }}
              sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                py: 2,
                background: 'white',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                overflow: 'hidden',
                zIndex: 200,
              }}
            >
              <IconButton
                onClick={handleCloseCartmobile}
                sx={{
                  position: 'absolute',
                  right: 0.5,
                  top: 0.5,
                }}
              >
                <CloseIcon
                  fontSize="medium"
                  sx={{
                    color: 'text.secondary',
                  }}
                ></CloseIcon>
              </IconButton>
              <StickyBarBottom
                data={data}
                showItem={{ combo: false, discount: true }}
                wrapBtnProps={{
                  direction: { xs: 'column', sm: 'row' },
                  sx: {
                    '& .main-btn': {
                      minHeight: { xs: '46px', lg: 'unset' },
                    },
                  },
                }}
                onClickScrollReviews={handleScrollReviews}
              />
            </Box>
          )}
        </AnimatePresence>
      )}

      {!isMobile && (
        <AnimatePresence mode="wait">
          <Box
            sx={{
              background: 'white',
              position: 'fixed',
              bottom: 0,
              left: 0,
              zIndex: isInview ? 10 : -2,
              width: '100%',
              borderBottom: '1px solid #BBBBBA',
              opacity: isInview ? 1 : 0,
              transform: isInview ? 'translateY(0)' : 'translateY(100%)',
              transition: 'opacity 0.3s ease, transform 0.3s ease, height 0.3s ease',
              pointerEvents: isInview ? 'auto' : 'none',
              height: isInview ? 'auto' : 0,
              borderTop: '1px solid #BBBBBA',
            }}
          >
            <ContainerCustom component={'div'}>
              <ContentFixedProductV2 data={data} />
            </ContainerCustom>
          </Box>
        </AnimatePresence>
      )}
      {children}
    </>
  )
}
